import { ListViewProvider, useListView } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { UsersListHeader } from './components/header/UsersListHeader'
import { KTCard, KTIcon } from '../../../../../_metronic/helpers'
import { UsersTable } from './table/UsersTable'
import { PatientTabs } from '../PatientPage'
import { ExactSearchInput } from '../../../../components/SearchInputs'
import { numberFormat } from '../../../../utils/Functions'
import { inputOnlyPrice } from '../../../../utils/Helper'
import { Button, Form, Row, Col, InputGroup } from 'react-bootstrap'
import { useMemo, useEffect, useState, useRef } from 'react'
import { useReactToPrint } from 'react-to-print';
import moment from 'moment'
import teethImage from '../../../../../assets/images/teeth.jpeg'
import DatePicker from '../../../../components/DatePicker'
import _ from 'lodash'
import Select from 'react-select';
import CSVExporter from '../../../../components/CSVExporter'
import api from '../../../../utils/Api'
import { useParams, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../../auth/core/Auth'
import PatientTeethChart from '../../../../components/PatientTeethChart'

const states = [{
  label: 'สำเร็จ',
  value: 'completed',
  color: 'success',
  buttonVariant: 'outline-danger'
}, {
  label: 'กำลังรักษา',
  value: 'treating',
  color: 'info',
  buttonVariant: 'success'
}, {
  label: 'รอชำระเงิน',
  value: 'pending-payment',
  color: 'warning',
  buttonVariant: 'primary'
}, {
  label: 'รอคิว',
  value: 'queued',
  color: 'primary',
  buttonVariant: 'outline-info'
},]

const methods: any = [
  {
    value: 'payByCash',
    label: 'เงินสด'
  },
  {
    value: 'payByBank',
    label: 'โอนเงิน'
  },
  {
    value: 'payByCreditCard',
    label: 'บัตรเครดิต'
  },
  {
    value: 'payByWelfare',
    label: 'ประกันสังคม'
  },
  {
    value: 'payByQuotaDiscount',
    label: 'วางบิล'
  },
  {
    value: 'payByDeposit',
    label: 'เงินฝาก'
  },
]

const pageStyle = () => (`
      .pagebreak {
        display: none;
      }


      body,html {
        padding: 0!important;
        margin: 0!important;
        font-size: 15px!important;
        background-color: white!important;
        line-height: 1;
      }

      body.print-receipt {
        min-width: 0px!important;
      }

      @page {
        size: A4 portrait;
      }

      .print-container {
        padding: 5mm;
      }

      .center {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
      .with-border {
        border-top: 2px solid black;
        border-bottom: 2px solid black;
        padding: 1rem 0px;
      }
      .with-border-bottom {
        border-bottom: 2px solid black;
        padding: 0px 0px 1rem 0px;
      }
      .items-container {
        margin: 1rem 0px;
      }
      .pagebreak {
        page-break-before: always;
      }
      .item {
        display: flex;
        justify-content: space-between;
      }
      .text-center {
        text-align: center;
      }
      .my-2 {
        margin:0.75rem 0;
      }
      .mt-5 {
        margin-top: 2rem;
      }
      .px-3 {
        padding-left: 1rem;
        padding-right: 1rem;
      }
      .mt-3 {
        margin-top: 1rem;
      }
      .my-3 {
        margin-top: 1rem;
        margin-bottom: 1rem;
      }
      .mb-3 {
        margin-bottom: 1rem;
      }
      .mb-0 {
        margin-bottom: 0;
      }

      .signature-container {
        display: flex;
        justify-content: space-around;
        margin-top: 6rem;
        margin-bottom: 2rem;
      }

      .signature-line {
       border-bottom: 2px solid black;
       padding: 0px 0px 1rem 0px;
       margin-bottom: 1rem;
       width: 200px;
     }

      table {
        width: 100%;
        border-collapse: collapse;
        border-bottom: 1px solid black;
      }

      th, td {
      	border-collapse:collapse;
      	border: 1px solid black;
      	padding:0.5rem;
      }

      td {
        border-bottom: 0;
        border-top: 0;
      }
      .cross {
            position: relative;
            width: 20px;
            height: 20px;
      }

      .cross::before,
      .cross::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 3px;
        background-color: red!important;
        transform-origin: center;
      }

      .cross::before {
        transform: translate(-50%, -50%) rotate(45deg); /* Diagonal line */
      }

      .cross::after {
        transform: translate(-50%, -50%) rotate(-45deg); /* Opposite diagonal line */
      }
      .dot {
        width: 5px;
        height: 5px;
      }
      .circle {
        width: 15px;
        height: 30px;
      }
  `)

const UsersList = ({ isPatientShow }: any) => {
  const [params, setParams] = useState<any>({
    branchId: '', treatmentItemName: '', minPrice: '', maxPrice: '',
    startDate: null, endDate: null
  })
  const [data, setData] = useState<any>({})
  const { currentUser } = useAuth()
  const [treatments, setTreatments] = useState<Array<any>>([])
  const componentRef = useRef(null);
  const [searchParams] = useSearchParams()
  const [promotions, setPromotions] = useState([])

  const branch = data.branch?.branch || {}

  const { lineUid } = useParams()
  const [qs] = useSearchParams()

  useEffect(() => {
    api.request(`line-oa/ldc-user/${lineUid}`, (r, s) => {
      if (!s) return

      setData(r)
    }, {}, 'GET', { bearerToken: qs.get('token') || '' })
  }, [])

  return (
    <>
      <PatientTeethChart lineOa patientId={data.id} usePrimaryTeeth={data.usePrimaryTeeth} />
    </>
  )
}


export default UsersList
